import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ShareButtonComponent } from './share-button.component';
import { ShareMenuComponent } from './share-menu.component';

@NgModule({
	declarations: [
		ShareButtonComponent,
		ShareMenuComponent
	],
	imports: [
		CommonModule,
		IonicModule
	],
	exports: [
		ShareButtonComponent
	]
})
export class ShareButtonComponentModule {
	constructor() {

	}
}
